import axios from "axios";
import Config from "../common/Config";
import FieldState from "../common/FieldState";
import OrderFormStep from "../common/OrderFormStep";
import FormTitle from "../components/formTitle/FormTitle";
import MuiRadio from "../components/radio/MuiRadio";
import MuiCheckbox from "../components/checkbox/MuiCheckbox";
import InputTextField from "../components/textField/InputTextField";
import MuiDatePicker from "../components/datePicker/MuiDatePicker";
import Button from "../components/button/Button";
import SecondaryButton from "../components/button/SecondaryButton";
import { CreateNotification } from "../components/notification/Notification";
import SaveAsDraft from "../components/modal/SaveAsDraft";
import "react-datepicker/dist/react-datepicker.css";
import ClearOrder from "../components/modal/ClearOrder";
import {
  Alert,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

export default class FootSelection extends OrderFormStep {
  constructor(props) {
    super(props);

    this.state = {
      isSubmit: false,
      footTypes: [],
      footMaterials: [],
      impactLevels: [],
      footOptionCombinations: [],
      footCategories: [],
      footShells: [],
      addFootOptions: [],
      formState: {
        addFoot: new FieldState(true),
        footType: new FieldState(false),
        footMaterial: new FieldState(false),
        footImpact: new FieldState(false),
        footShell: new FieldState(false),
      },
    };
  }

  async loadCart() {
    let cart = [];

    let currentType = this.state.formState.footType.value;
    let currentImpact = this.state.formState.footImpact.value;
    let currentCategory = this.state.footCategories.filter(c => c.impactId===currentImpact)[0]?.category;
    let currentMaterial = this.state.formState.footMaterial.value;
    let partnumber = this.state.footOptionCombinations.filter(
      c => c.footTypeId === currentType 
        && (c.impactId == null || c.impactId === currentImpact)
        && c.category === currentCategory
        && c.materialId === currentMaterial
    )[0]?.partNumber;

    if(partnumber) {
      cart.push({
        name: "Selected Foot",
        partNumber: partnumber,
        quantity: 1,
        price: -1
      });
    }

    

    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };


    config.params = {
      footShellId: this.state.formState.footShell.value,
      footTypeId: this.state.formState.footType.value
    };
    let shellPartResponse = await axios.get(
      Config.baseApiUrl + "footShellPartNumber/" + this.props.formTypeId +"/",
      config
    );
    if(shellPartResponse && shellPartResponse.data && shellPartResponse.data.length > 0) {
      cart.push({
        name: "Foot Shell",
        partNumber: shellPartResponse.data,
        quantity: 1,
        price: -1
      });
    }


    config.params = {
      cart: cart.map(x => x.partNumber)
    };
    return axios.get(
      Config.baseApiUrl + "kneebundleprice/" + this.props.formTypeId +"/",
      config
    ).then(response => {
      let data = response.data

      cart = cart.map(c => {
        return {
          name: c.name,
          partNumber: c.partNumber,
          quantity: c.quantity,
          price: data.filter(x => x.partNumber === c.partNumber)[0]?.price,
          sourceId: c.sourceId
        }
      });

      cart = cart.concat(data.filter(d => d.sourceId !== null).map(d => {
        return {
          name: d.name,
          partNumber: d.partNumber,
          quantity: d.quantity,
          price: d.price,
          sourceId: d.sourceId
        }
      }));
      
      this.props.setTempCart(cart);
    }).catch(error =>{
      console.log(error)
    });
  }


  isRequired() {
    return this.state.formState.addFoot.value === 277;
  }

  updateRequirements() {
    var formState = this.state.formState;
    var required = this.isRequired();
    
    formState.footType.isRequired = required;
    formState.footMaterial.isRequired = required;
    formState.footImpact.isRequired = required;
    formState.footShell.isRequired = required;

    this.setState({
      formState: formState
    });
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
      this.setState({
        footTypes: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "footType" },
            }
          )
        ).data,
        addFootOptions: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "includeFoot" },
            }
          )
        ).data,
        footShells: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "footShell" },
            }
          )
        ).data,
        footMaterials: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "footMaterial" },
            }
          )
        ).data,
        impactLevels: (
          await axios.get(
            Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
            {
              params: { fieldName: "footImpact" },
            }
          )
        ).data,
      });

      let footData = await axios.get(
        Config.baseApiUrl + "foot/" + this.props.formTypeId,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
          }
        }
      );

      this.setState({
        footOptionCombinations: footData.data.options,
        footCategories: footData.data.categories
      });

      let config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
        },
        params: {
          fieldNames: [
            "footType",
            "footMaterial",
            "footImpact",
            "includeFoot",
            "footShell",
          ],
        },
      };

      const { data } = await axios.get(
        Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
        config
      );
      let formState = this.state.formState;
      formState.footType.value = data.find(
        (fi) => fi.fieldName === "footType"
      )?.fieldOptionId;

      formState.addFoot.value = data.find(
        (fi) => fi.fieldName === "includeFoot"
      )?.fieldOptionId;

      formState.footMaterial.value = data.find(
        (fi) => fi.fieldName === "footMaterial"
      )?.fieldOptionId;

      formState.footImpact.value = data.find(
        (fi) => fi.fieldName === "footImpact"
      )?.fieldOptionId;

      formState.footShell.value = data.find(
        (fi) => fi.fieldName === "footShell"
      )?.fieldOptionId;

      this.setState({
        formState: formState,
      });

      this.loadCart();
    

    this.setState({ isLoaded: true });
  }

  saveData() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    let data = [];

    
    data.push({
      fieldName: "includeFoot",
      fieldOptionId: this.state.formState.addFoot.value,
    });
    
    if (this.isRequired()) {
      data.push({
        fieldName: "footType",
        fieldOptionId: this.state.formState.footType.value,
      });

      data.push({
        fieldName: "footImpact",
        fieldOptionId: this.state.formState.footImpact.value,
      });

      data.push({
        fieldName: "footShell",
        fieldOptionId: this.state.formState.footShell.value,
      });

      data.push({
        fieldName: "footMaterial",
        fieldOptionId: this.state.formState.footMaterial.value,
      });
    }

    if (this.validateData().isValid) {
      return axios.post(
        Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
        data,
        config
      );
    } else {
      this.setState({
        isSubmit: true,
      });
      CreateNotification(this.validateData().errorMessage, "error");

      return;
    }
  }

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();


    let validFootTypes = this.state.footTypes.filter(ft => {
      return this.state.footOptionCombinations.some(c => c.footTypeId === ft.id)
    }
    );

    let currentType = this.state.formState.footType.value;
    let validMaterials = this.state.footMaterials.filter(m =>
      this.state.footOptionCombinations.some(c => c.footTypeId === currentType 
                                          && c.materialId === m.id)
    );

    let currentMaterial = this.state.formState.footMaterial.value;

    let validImpacts = this.state.impactLevels.filter(m =>
      this.state.footOptionCombinations.some(c => c.footTypeId === currentType 
            && c.materialId === currentMaterial
            && c.impactId === m.id)
    );

    let currentImpact = this.state.formState.footImpact.value;
    let currentCategory = this.state.footCategories.filter(c => c.impactId===currentImpact)[0]?.category;
    let partnumber = this.state.footOptionCombinations.filter(
      c => c.footTypeId === currentType 
        && (c.impactId == null || c.impactId === currentImpact)
        && c.category === currentCategory
        && c.materialId === currentMaterial
    )[0]?.partNumber;

    return (
      <>
        <div className="checkFormWrapper">
          <FormTitle
            title="Product Information"
            description=""
          />

          <form className="checkform" onSubmit={e => {e.preventDefault()}}>
            <div className="fieldBorder">
                <MuiRadio
                  options={this.state.addFootOptions}
                  defaultValue={this.state.formState.addFoot.value}
                  label="Add a Foot?"
                  required={this.state.formState["addFoot"].isRequired}
                  error={this.handleError("addFoot") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "addFoot");
                    this.updateRequirements();
                  }}
                />
              </div>

            {this.isRequired() && 
            <>
              <div className="fieldBorder">
                <MuiRadio
                  options={validFootTypes}
                  defaultValue={currentType}
                  label="Foot Type"
                  required={this.state.formState["footType"].isRequired}
                  error={this.handleError("footType") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "footType");
                  }}
                />
              </div>

              <div className="fieldBorder">
                <MuiRadio
                  options={validMaterials}
                  defaultValue={currentMaterial}
                  label="Material"
                  required={this.state.formState["footMaterial"].isRequired}
                  error={this.handleError("footMaterial") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "footMaterial");
                  }}
                />
              </div>
              
              <div className="fieldBorder">
                <MuiRadio
                  options={validImpacts}
                  defaultValue={currentImpact}
                  label="Impact"
                  required={this.state.formState["footImpact"].isRequired}
                  error={this.handleError("footImpact") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "footImpact");
                  }}
                />
              </div>

              <div className="msgBox fieldBorder msgBoxWidth">
                <h4 className="headLable"><b>Selected Foot:</b> {partnumber}</h4>
              </div>

              <div className="fieldBorder">
                <MuiRadio
                  options={this.state.footShells}
                  defaultValue={this.state.formState.footShell.value}
                  label="Foot Shell"
                  required={this.state.formState["footShell"].isRequired}
                  error={this.handleError("footShell") && this.state.isSubmit}
                  checked
                  onChange={(e) => {
                    this.onRadioChange(e, "footShell");
                  }}
                />
              </div>
            </>}

          </form>
        </div>

        <div className="handelButtons">
          <SecondaryButton
            text="Save As Draft"
            onClick={this.props.handleClickOpen}
          />
          <SecondaryButton
            text = "Clear the Order?"
            onClick = {this.props.handleClickClearOpen}
          />
          <div className="stepBtn">
            <SecondaryButton
              text="Back"
              onClick={() => this.props.handleBack(this.props.currentIndex - 1)}
              disabled={
                this.props.activeOuterStep === 0 && this.props.innerStep === 0
              }
            />
            <Button
              text="Next"
              disabled={this.state.isLoading}
              onClick={async () => {
                try {
                  this.setState({ isLoading: true });
                  const res = await this.saveData();
                  if (res.status === 204) {
                    this.props.handleNext(3);
                    this.setState({ isLoading: false });
                    CreateNotification("Submitted", "success");
                  }
                } catch (err) {
                  this.setState({ isLoading: false });
                }
              }}
            />
          </div>
        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
        <ClearOrder
          openClear={this.props.openClear}
          handleCloseClear={this.props.handleCloseClear}
          showClear={this.props.showClear}
          setShowClear={this.props.setShowClear}
          formId = {this.props.formTypeId}
          handleClearBack={this.props.handleClearBack}
        />
      </>
    );
  }
}
